/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Cue_1Inputs */

const en_us2_workout_cue_1 = /** @type {(inputs: Workout_Cue_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take a deep breath and let your arms hang loose.`)
};

const pt_br2_workout_cue_1 = /** @type {(inputs: Workout_Cue_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respire fundo e solte os braços.`)
};

const es_419_workout_cue_1 = /** @type {(inputs: Workout_Cue_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respira hondo y deja los brazos sueltos.`)
};

const pt_pt2_workout_cue_1 = /** @type {(inputs: Workout_Cue_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respira fundo e solta os braços.`)
};

const fr_fr2_workout_cue_1 = /** @type {(inputs: Workout_Cue_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respire profondément et relâche les bras.`)
};

const de_de2_workout_cue_1 = /** @type {(inputs: Workout_Cue_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atme tief ein und lass die Arme locker hängen.`)
};

const it_it2_workout_cue_1 = /** @type {(inputs: Workout_Cue_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai un respiro profondo e lascia le braccia sciolte.`)
};

/**
* | output |
* | --- |
* | "Take a deep breath and let your arms hang loose." |
*
* @param {Workout_Cue_1Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_cue_1 = /** @type {((inputs?: Workout_Cue_1Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Cue_1Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_cue_1(inputs)
	if (locale === "es-419") return es_419_workout_cue_1(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_cue_1(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_cue_1(inputs)
	if (locale === "de-DE") return de_de2_workout_cue_1(inputs)
	if (locale === "it-IT") return it_it2_workout_cue_1(inputs)
	return en_us2_workout_cue_1(inputs)
});
export { workout_cue_1 as "workout.cue_1" }